
import img1 from '../images/cosmos/130450932_110225667612487_2397097314206639749_o.jpg';
import img2 from '../images/cosmos/Dimitar-Bracov.jpg';
import img3 from '../images/cosmos/hristo-tanev-01-07-16-4.jpg';
import img4 from '../images/cosmos/Jordan-Atanasov1.jpg';
import img5 from '../images/cosmos/korica-ptici-v-noshta1-190x122.jpg';
import img6 from '../images/cosmos/Liliev.jpg';
import img7 from '../images/cosmos/uchrediteli-klub-Kosmos-23-13.jpg';

// eslint-disable-next-line
export default [
    {
        sys: {
            id: "1",

        },
        fields: {
            name: "one",
            src: img1
        }
    }, {
        sys: {
            id: "2",

        },
        fields: {
            name: "Dimitar-Bracov",
            src: img2
        }
    },
    {
        sys: {
            id: "3",

        },
        fields: {
            name: "hristo-tanev",
            src: img3
        }
    },
    {
        sys: {
            id: "4",

        },
        fields: {
            name: "Jordan-Atanasov",
            src: img4
        }
    },
    {
        sys: {
            id: "5",

        },
        fields: {
            name: "korica-ptici-v-noshta1",
            src: img5
        }
    },
    {
        sys: {
            id: "6",

        },
        fields: {
            name: "Liliev-konkurs",
            src: img6
        }
    },
    {
        sys: {
            id: "7",

        },
        fields: {
            name: "uchrediteli-klub-Kosmos",
            src: img7
        }
    }
]